import { useContext } from 'react';
import { DepartmentContext } from './DepartmentContext';

export const useDepartments = () => {
  const context = useContext(DepartmentContext);
  if (!context) {
    throw new Error("useDepartments must be used within a DepartmentProvider");
  }
  return context;
};
